import React, { createContext, useContext, useState } from "react";

const PincodeContext = createContext();

export const PincodeProvider = ({ children }) => {
  const [pincode, setPincodeState] = useState(() => localStorage.getItem("pincode") || "");
  const [isModalOpen, setIsModalOpen] = useState(() => !localStorage.getItem("pincode"));

  const setPincode = (value) => {
    localStorage.setItem("pincode", value);
    setPincodeState(value);
    setIsModalOpen(false);
    window.location.reload();
  };

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <PincodeContext.Provider value={{ pincode, setPincode, isModalOpen, openModal, closeModal }}>
      {children}
    </PincodeContext.Provider>
  );
};

export const usePincode = () => useContext(PincodeContext);
